import { useEffect, useState } from 'react';

import {
  DEFAULT_RUNTIME_FEATURE_FLAGS,
  RuntimeFeatureFlags,
  runtimeFeatureFlagsService,
} from '../services/runtimeFeatureFlagsService';

/**
 * Server-owned runtime flags, for components that need them during render.
 *
 * Starts from the permissive default and settles once the value arrives, so a
 * feature is never briefly hidden from the people who do have it — the opposite
 * of `useButtonPermissions`, which fails closed while loading because it guards
 * write actions. This one only chooses which file types a picker offers; the
 * API enforces the switch regardless of what the UI drew first.
 *
 * The service memoizes after the first call, so mounting this in several places
 * costs one request per app session.
 */
export const useRuntimeFeatureFlags = (): RuntimeFeatureFlags => {
  const [flags, setFlags] = useState<RuntimeFeatureFlags>(
    DEFAULT_RUNTIME_FEATURE_FLAGS,
  );

  useEffect(() => {
    let cancelled = false;
    runtimeFeatureFlagsService.get().then(next => {
      if (!cancelled) {
        setFlags(next);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return flags;
};
